import { action, computed, makeObservable, observable } from 'mobx'

import type { SubscribeStatus } from '@/service/curriculumCore.model'

export class DropdownNode<T = string> {
  get id() {
    return this._id
  }

  get value() {
    return this._value
  }

  _checked = false
  get checked() {
    return this._checked
  }

  get disabled() {
    return this._disabled
  }
  get subscribeStatus() {
    return this._subscribeStatus
  }
  constructor(
    private _id: T,
    private _value: string,
    _checked: boolean = false,
    private _disabled: boolean = false,
    private _subscribeStatus: SubscribeStatus = 'SUBSCRIBED',
  ) {
    makeObservable(this, {
      id: computed,
      value: computed,
      _checked: observable,
      subscribeStatus: computed,
      checked: computed,
      disabled: computed,
      updateChecked: action,
    })
    this._checked = _checked
  }

  updateChecked(checked: boolean) {
    this._checked = checked
  }
}
